import _defineProperty from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

/**
 * Path.js
 *
 * Copyright (c) apploft. GmbH
 */
import { pathsByMethod } from './APIDefinition';
/**
 * Returns the body schema in `path`.
 *
 * @param {Object} path The path object with `parameters`.
 */

function bodySchema(_ref) {
  var parameters = _ref.parameters;
  var candidates = parameters.filter(function (p) {
    return p.in === 'body';
  });
  console.assert(candidates.length === 1, 'expected ONE body');
  return candidates[0];
}
/**
 * Find POST route in `paths`.
 *
 * @param {Array<Object>} paths An Array of paths.
 */


function findPost(paths) {
  var found = pathsByMethod(paths, 'post');
  console.assert(found.length === 1, 'expected one POST path');
  var path = found[0];
  var pathID = path.pathID;
  console.assert(pathID.method === 'post', pathID);
  return path;
}

function createParametersFilter(objectId) {
  if (!objectId) {
    return function (p) {
      return !p.parameters;
    };
  }

  return function (p) {
    return p.parameters;
  };
}

function findSingly(method, paths, objectId) {
  var candidates = pathsByMethod(paths, method);
  var found = candidates.filter(createParametersFilter(objectId));

  if (!found.length) {
    return null;
  }

  console.assert(found.length === 1, 'single generic GET expected');
  var path = found[0];
  var pathID = path.pathID;
  console.assert(pathID.method === method, pathID);
  return path;
}
/**
 * Returns GET path in `paths` for `objectId`.
 *
 * @param {*} paths
 * @param {string} objectId
 */


function findGet(paths, objectId) {
  return findSingly('get', paths, objectId);
}
/**
 * Returns PUT path in `paths` for `objectId`.
 *
 * @param {*} paths
 * @param {string} objectId
 */


function findPut(paths, objectId) {
  return findSingly('put', paths, objectId);
}
/**
 * Returns DELETE path in `paths` for `objectId`.
 *
 * @param {*} paths
 * @param {string} objectId
 */


function findDelete(paths, objectId) {
  return findSingly('delete', paths, objectId);
}
/**
 * Returns widget properties of the `POST` route in `paths`.
 *
 * @param {*} paths Paths of an endpoint (section).
 */


function findPostProps(paths) {
  var path = findPost(paths);

  var _bodySchema = bodySchema(path),
      schema = _bodySchema.schema,
      name = _bodySchema.name;

  if (!schema) {
    throw new Error('no schema');
  }

  var properties = schema.properties;

  if (!properties) {
    var key = name;
    return _defineProperty({}, key, schema);
  }

  return properties;
}

export { findPost, bodySchema, findPostProps, findGet, findPut, findDelete };